<script setup lang="ts">
  import { GlobalSearchProvider } from '@gat-ship/search'
  import { StakeholderSearchProvider } from '@gat-ship/stakeholders'
  import { ConfirmDialogProvider } from '@gat-ship/shared'
  import { DatabaseProvider } from '@gat-ship/lib/database-provider'
  import { SignalRProvider } from '@gat-ship/lib/signalr'
  import { UserProvider } from '@gat-ship/lib/user'
  import { SupportSessionProvider } from '@gat-ship/lib/support-session'
  import { AppStateProvider } from '@gat-ship/lib/app-state'
  import { FeatureFlagProvider } from '@gat-ship/lib/feature-flag'
  import { GlobalSettingsProvider } from '@gat-ship/lib/global-settings'
  import AppInitialization from './AppInitialization.vue'
  import { GsCloudBackendProvider } from '@gat-ship/lib/http-client'
  import { RefDataProvider } from '@gat-ship/lib/ref-data'
</script>
<template>
  <gs-cloud-backend-provider _is-global>
    <database-provider>
      <support-session-provider>
        <signal-r-provider>
          <user-provider>
            <app-state-provider>
              <feature-flag-provider>
                <global-settings-provider>
                  <GlobalSearchProvider>
                    <StakeholderSearchProvider>
                      <ConfirmDialogProvider>
                        <app-initialization>
                          <ref-data-provider>
                            <slot />
                          </ref-data-provider>
                        </app-initialization>
                      </ConfirmDialogProvider>
                    </StakeholderSearchProvider>
                  </GlobalSearchProvider>
                </global-settings-provider>
              </feature-flag-provider>
            </app-state-provider>
          </user-provider>
        </signal-r-provider>
      </support-session-provider>
    </database-provider>
  </gs-cloud-backend-provider>
</template>
